import { connect, useDispatch } from 'react-redux';
import React, { useEffect } from 'react';
import './nias-change-subject.scss';
import { AUTH_TOKEN_KEY, successLogin } from 'app/shared/reducers/authentication';
import axios from 'axios';
import { IUser, JWTUser } from 'app/shared/model/user.model';
import jwt from 'jwt-decode';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader } from 'app/shared/loader/loader';
import { SESSION_STORAGE_KEYS } from 'app/shared/util/local-storage-keys';

const NiasChangeSubject = (props: StateProps) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  // Helper function to parse query parameters
  const getQueryParams = search => {
    return new URLSearchParams(search);
  };

  useEffect(() => {
    const queryParams = getQueryParams(location.search);
    const httpParams = {
      forPersonOib: queryParams.get('ForPersonOib'),
      forIps: queryParams.get('ForIps'),
      forIzvorReg: queryParams.get('ForIzvorReg'),
      toIps: queryParams.get('ToIps'),
      toIzvorReg: queryParams.get('ToIzvorReg'),
    };
    sessionStorage.setItem('forPersonOib', queryParams.get('ForPersonOib'));
    sessionStorage.setItem('forIps', queryParams.get('ForIps'));
    sessionStorage.setItem('forIzvorReg', queryParams.get('ForIzvorReg'));
    sessionStorage.setItem('toIps', queryParams.get('ToIps'));
    sessionStorage.setItem('toIzvorReg', queryParams.get('ToIzvorReg'));
    axios.get('/api/change-subject', { params: httpParams })
      .then(response => {
        const token = response.data.id_token;
        localStorage.setItem(AUTH_TOKEN_KEY, token);
        const user: JWTUser = jwt(token);
        const iuser: IUser = {
          id: user.idUser,
          firstName: user.firstName,
          lastName: user.lastName,
          authorities: user.authorities,
          userSelected: user.userSelected,
          szIsZastupanje: user.szIsZastupanje,
          szIpsRegistar: user.szIpsRegistar,
          szSubjectOfRepresentationSelected: user.szSubjectOfRepresentationSelected,
          mandate: user.mandate
        };
        dispatch(successLogin(iuser));
        window.location.href = `${sessionStorage.getItem(SESSION_STORAGE_KEYS.FROM_URL) ?? '/'}`;
        sessionStorage.removeItem(SESSION_STORAGE_KEYS.FROM_URL);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []);

  return (
    <div className="h-100">
      <Loader />
    </div>
  );
};

const mapStateToProps = ({ keycloak }) => ({
  autoRedirectToNias: keycloak.autoRedirectToNias,
});

type StateProps = ReturnType<typeof mapStateToProps>;

export default connect(mapStateToProps, null)(NiasChangeSubject);
